exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  position: absolute;\n  width: 100%;\n  height: 100%; }\n  @media (min-width: 520px) {\n    :host {\n      max-width: 520px;\n      max-height: 800px;\n      left: calc(50% - (520px / 2)); } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = 1